<template>
  <div v-if="src" class="hc-zoom" data-testid="hc-zoom-root">
    <div class="hc-zoom__frame">
      <img
        class="hc-zoom__image"
        :src="src"
        :alt="alt"
        loading="lazy"
        :style="{ transform: `scale(${scale})` }"
      />
      <div class="hc-zoom__controls">
        <button
          type="button"
          class="hc-zoom__btn"
          aria-label="Zoom out"
          data-testid="hc-zoom-out"
          :disabled="scale <= MIN_SCALE"
          @click="zoomOut"
        >
          &minus;
        </button>
        <button
          type="button"
          class="hc-zoom__btn"
          aria-label="Reset zoom"
          data-testid="hc-zoom-reset"
          @click="reset"
        >
          {{ Math.round(scale * 100) }}%
        </button>
        <button
          type="button"
          class="hc-zoom__btn"
          aria-label="Zoom in"
          data-testid="hc-zoom-in"
          :disabled="scale >= MAX_SCALE"
          @click="zoomIn"
        >
          &plus;
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { safeUrl } from '../../blockConfig';

const MIN_SCALE = 1;
const MAX_SCALE = 3;
const STEP = 0.25;

export default {
  name: 'ImageZoomBlock',
  props: {
    config: { type: Object, default: () => ({}) },
  },
  data() {
    return { scale: MIN_SCALE, MIN_SCALE, MAX_SCALE };
  },
  computed: {
    src() {
      return safeUrl(this.config && this.config.src);
    },
    alt() {
      return (this.config && this.config.alt) || '';
    },
  },
  methods: {
    zoomIn() {
      this.scale = Math.min(MAX_SCALE, this.scale + STEP);
    },
    zoomOut() {
      this.scale = Math.max(MIN_SCALE, this.scale - STEP);
    },
    reset() {
      this.scale = MIN_SCALE;
    },
  },
};
</script>

<style src="./styles/ImageZoomBlock.scss" lang="scss" scoped></style>
